"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _semanticUiReact = require("semantic-ui-react");
var R = _interopRequireWildcard(require("ramda"));
var _actions = require("../../collections/store/actions");
var _selectors = require("../../collections/store/selectors");
var _Collection = _interopRequireDefault(require("../../collections/components/Collection"));
var _withDeleteCollectionProps = _interopRequireDefault(require("../../collections/hocs/withDeleteCollectionProps"));
var _withEditableCollectionProps = _interopRequireDefault(require("../../collections/hocs/withEditableCollectionProps"));
var _CompactCardView = _interopRequireDefault(require("../../CompactCardView"));
var _Hotel = _interopRequireDefault(require("../../collections/components/Hotel"));
var _withDeleteHotelProps = _interopRequireDefault(require("../../collections/hocs/withDeleteHotelProps"));
var _Loader = _interopRequireDefault(require("../../ui/Loader"));
var _LocalState = _interopRequireDefault(require("../../LocalState"));
var _OpenHotelButton = require("../../OpenHotelButton");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var collectionEnhancer = R.compose(_withDeleteCollectionProps.default, _withEditableCollectionProps.default);
var Collection = collectionEnhancer(_Collection.default);
var Hotel = (0, _withDeleteHotelProps.default)(_Hotel.default);
var getMedianaIndex = function getMedianaIndex(collections) {
  return R.call(R.pipe(R.length, function (count) {
    return count / 2;
  }, Math.ceil), collections);
};
var mapperWithIndex = R.addIndex(R.map);
var CollectionsPage = function CollectionsPage() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('COLLECTIONS_PAGE'),
    t = _useTranslation.t;
  var ui = (0, _reactRedux.useSelector)(_selectors.getFetchCollectionsUI);
  var collections = (0, _reactRedux.useSelector)(_selectors.getCollections);
  var columns = (0, _react.useMemo)(function () {
    return R.filter(function (column) {
      return !R.isEmpty(column);
    }, [R.take(getMedianaIndex(collections), collections), R.drop(getMedianaIndex(collections), collections)]);
  }, [collections]);
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.getCollections)());
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
    columns: 1
  }, ui.loading && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_Loader.default, {
    label: t('DOWNLOAD_COLLECTIONS')
  })), ui.completed && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.container
  }, R.isEmpty(collections) ? 'EMPTY_STATE' : mapperWithIndex(function (collectionsByColumn, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.col,
      key: index
    }, R.map(function (_ref) {
      var id = _ref.id,
        hotels = _ref.hotels,
        name = _ref.name,
        type = _ref.type;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.item,
        key: id
      }, /*#__PURE__*/_react.default.createElement(_LocalState.default, {
        initial: false
      }, function (isCollapsed, onCollapseButtonClick) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: _styles.default.body
        }, /*#__PURE__*/_react.default.createElement(Collection, {
          className: _styles.default.noHover,
          hotels: hotels,
          id: id,
          isCollapsed: isCollapsed,
          key: id,
          name: name,
          type: type,
          onCollapseButtonClick: !R.isEmpty(hotels) ? function () {
            return onCollapseButtonClick(!isCollapsed);
          } : undefined
        }), isCollapsed && /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Collapse, {
          className: _styles.default.list
        }, R.map(function (hotel) {
          return /*#__PURE__*/_react.default.createElement(Hotel, {
            cityName: hotel.city.name,
            className: _styles.default.hotel,
            collectionID: id,
            id: hotel.id,
            image: hotel.image,
            key: hotel.id,
            name: hotel.name,
            stars: hotel.stars,
            onOpenHotelPage: function onOpenHotelPage() {
              return (0, _OpenHotelButton.openHotelPage)({
                hotelID: hotel.id
              });
            }
          });
        }, hotels)));
      }));
    }, collectionsByColumn));
  }, columns))));
};
var _default = exports.default = (0, _react.memo)(CollectionsPage);